import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import backImage from "../../../assets/icons/arrow-back-black.svg";
import ProgressIndicator from "./ProgressIndicator";
import SecureImage from "../../../components/common/SecureImage";
import MaleActive from "../../../assets/images/ic_male_active.png";
import FemaleActive from "../../../assets/images/ic_female_active.png";
import { logEventWithData } from "../../../app/eventSlice";
import { getProvider, setStateFromPayload, checkConfig } from "../navigoSlice";
import { useHistory, useLocation } from "react-router";
import BackButton from "../../../components/common/BackButton";
import { NavigoFinalSectionContent } from "./navigoFinalSection";
import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import { AddressBookContent } from "../../address/newIndex";
import { getFamilyData, getPriceForFamily } from "../../familyInfo/familySlice";
import { clearPricesForFamily } from "../../familyInfo/familySlice";
import useUnhidePageOnEnter from "../../../hooks/useUnhidePageOnEnter";
import { goBackTo, withFrom } from "../utils/navBack";
// Content carries all the logic and renders NO IonPage: this screen is
// rendered inside other pages. The default export below adds the IonPage
// for the route. One IonPage per route - a nested one overwrites the
// route's viewItem.ionPageElement via registerIonPage.
export function BookingForSectionContent({ providerData: provider }) {
  const routeLocation = useLocation();
  // Ionic can leave this page `ion-page-hidden` on re-entry, blanking it.
  const navigoStore = useSelector((store) => store.navigo);
  // const location = useLocation();
  // const services = location?.state?.service;
  const dispatch = useDispatch();
  const pricesForFamily = useSelector(
    (state) => state.familyInfo.pricesForFamily
  );
  const patientProfile = useSelector(
    (store) => store.login.user?.patientProfile
  );
  const familyStore = useSelector((store) => store.familyInfo);
  const [finalPage, setFinalPage] = useState(false);
  const [familyMember, setFamilyMember] = useState();
  const [memberRelation, setMemberRelation] = useState(0);
  const history = useHistory();
  const [selfPrice, setSelfPrice] = useState(null);
  // const [price, setPrice] = useState(0);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  // Which ROW is selected, kept separate from which member is being booked.
  //
  // `selectedMemberId` is the memberPatientId and must stay that way: pricing
  // is keyed by it and it is what travels downstream into /select-address and
  // the booking. But QA hit two family records sharing (or missing) a
  // memberPatientId, and since the radio compared on that, tapping one lit
  // both. Row identity is `fd.id`, which is already unique — it is the React
  // key — so the radio compares on this instead and exactly one row lights.
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [hasUserSelected, setHasUserSelected] = useState(false);
  const [addressBook, setAddressBook] = useState(false);
  const [loading, setLoading] = useState(false);
  const priceFetchedRef = useRef(false);
  const {
    isForFamily,
    familyMemberSelected,
    familyMemberSelectedData,
    currentServices,
    familyMembers,
    isUserSelectedFamily,
    currentSelectedService: service,
    currentSelectedPlan: planId,
    isCmpBooking,
  } = navigoStore.ui;
  const {
    loadedFamily,
    loadedRelation,
    fetchingFamily,
    fetchingRelations,
    familyData,
    relations,
    bookingFor,
    isPriceFetched,
  } = familyStore;

  const RELATIONS = [
    { code: 1, value: "Father" },
    { code: 2, value: "Father-in-law" },
    { code: 3, value: "Mother" },
    { code: 4, value: "Mother-in-law" },
    { code: 5, value: "Spouse" },
    { code: 6, value: "Daughter (below 18 years)" },
    { code: 7, value: "Daughter (above 18 years)" },
    { code: 8, value: "Son (below 18 years)" },
    { code: 9, value: "Son (above 18 years)" },
    { code: 10, value: "Others" },
  ];

  useEffect(() => {
    if (bookingFor && isPriceFetched) {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Reset selection when service changes
    setHasUserSelected(false);
    setSelectedMemberId(null);

    dispatch(
      setStateFromPayload({
        familyMemberSelected: null,
        familyMemberSelectedData: {},
        isUserSelectedFamily: false,
      })
    );
  }, [service?.serviceId]);

  useEffect(() => {
    if (patientProfile?.id && pricesForFamily?.[patientProfile.id]) {
      const price =
        pricesForFamily[patientProfile.id]?.serviceModeDetails?.[0]
          ?.discountedPrice;

      if (price !== undefined) {
        setSelfPrice(price);
      }
    }
  }, [pricesForFamily, patientProfile?.id]);

  function getRelationByCode(code) {
    return RELATIONS.find((relation) => relation.code === code) || null;
  }

  const handleAvailNow = (rowId) => {
    // Resolve the record by the row that was tapped. Matching on
    // memberPatientId returned the FIRST record that compared equal, so with
    // two records sharing (or missing) an id this could carry the wrong one's
    // relation into the booking.
    const matchedMember =
      rowId === -1 ? null : familyData.find((member) => member.id === rowId);
    // What goes downstream is unchanged: the memberPatientId, exactly as before.
    const familyMember =
      rowId === -1 ? -1 : matchedMember?.memberPatientId ?? selectedMemberId;

    if (matchedMember) {
      setMemberRelation(matchedMember.relation);
    }
    if (service?.serviceModeDetails[0]?.modeName != "Home sample") {
      setFinalPage(true);
    }
    setFamilyMember(familyMember === -1 ? patientProfile.id : familyMember);
    if (service?.serviceModeDetails[0]?.modeName === "Home sample") {
      history.push({
        pathname: "/select-address",
        state: withFrom(routeLocation, {
          addressOnly: true,
          service,
          planId,
          familyMember: familyMember === -1 ? patientProfile.id : familyMember,
          memberRelation: matchedMember ? matchedMember.relation : 0,
          price: selectedPrice,
        }),
      });
    }
  };
  useIonViewWillEnter(() => {
    // NOTE: do NOT reset `finalPage` here. It is a STATE of this page, not a
    // route, so anything that re-fires this page's enter lifecycle would bounce
    // straight back to the member list and re-run every fetch, making Continue
    // a no-op.
    //
    // (This used to be caused by NavigoFinalSection nesting its own <IonPage>
    // inside this one. That nesting is gone — it now renders
    // NavigoFinalSectionContent, which contributes no page — but the rule still
    // holds, because finalPage is page state either way.)
    //
    // Clear the selection only on the FIRST entry. Coming back from a
    // sub-screen should not wipe what the user already picked.
    if (!priceFetchedRef.current) {
      priceFetchedRef.current = true;

      setHasUserSelected(false);
      setSelectedRowId(null);
      setSelectedMemberId(null);

      dispatch(
        setStateFromPayload({
          familyMemberSelected: null,
          familyMemberSelectedData: {},
          isUserSelectedFamily: false,
        })
      );
    }

    // Refresh the family list and its prices on EVERY entry. This used to sit
    // inside the guard above, so it ran once per component lifetime: adding a
    // family member and coming back showed the new member with no price at all,
    // because getFamilyData and the per-member price calls both live in here
    // and neither ran a second time.
    continueAvailNow(service);
  });

  const getPriceForMember = (memberId) => {
    return (
      pricesForFamily?.[memberId]?.serviceModeDetails?.[0]?.discountedPrice || 0
    );
  };

  const continueAvailNow = async (service) => {
    setLoading(true);

    try {
      const resultAction = await dispatch(getFamilyData());
      const familyMembers = resultAction?.payload?.data || [];

      const pricePromises = [];

      const selfBody = {
        memberPatientId: patientProfile.id,
        memberRelation: 0,
        patientId: patientProfile.id,
        planId: service.planId,
        serviceId: service.serviceId,
        serviceMode: service.serviceModeDetails[0].modeName,
      };

      pricePromises.push(dispatch(getPriceForFamily(selfBody)));

      // Family pricing
      for (const fm of familyMembers) {
        const sameRelationPIds = familyMembers
          .filter((member) => member.relation === fm.relation)
          .map((member) => member.memberPatientId);

        const body = {
          memberPatientId: fm.memberPatientId,
          memberRelation: fm.relation,
          patientId: fm.patientId,
          planId: service.planId,
          serviceId: service.serviceId,
          serviceMode: service.serviceModeDetails[0].modeName,
          sameRelationPIds,
        };

        pricePromises.push(dispatch(getPriceForFamily(body)));
      }

      await Promise.all(pricePromises);

      if (isCmpBooking) {
        // CMP / avail care program: no provider selection. Fetch the
        // avail-specific booking config so the slots page can use its
        // min/max booking days.
        await dispatch(
          checkConfig({
            patientId: patientProfile.id,
            planId: service.planId,
            program: "avail",
          })
        );
      } else if (service?.serviceModeDetails?.[0]?.modeName !== "Home sample") {
        const providerBody = {
          cityMatch: [],
          landmarkMatch: [],
          languageMatch: [],
          pageNum: 0,
          pageSize: 0,
          patientId: patientProfile.id,
          planId: planId,
          serviceId: service?.serviceId,
          serviceMode: service?.serviceModeDetails?.[0]?.modeName,
          stateMatch: [],
        };

        await dispatch(getProvider(providerBody));
      }
    } catch (error) {
      console.error("Failed to fetch family/pricing", error);
    } finally {
      setLoading(false);
    }
  };

  const selectedPrice =
    selectedMemberId === -1
      ? selfPrice ?? 0
      : pricesForFamily?.[selectedMemberId]?.serviceModeDetails?.[0]
          ?.discountedPrice ?? 0;

  const selfServiceDetails =
    pricesForFamily?.[patientProfile?.id]?.serviceModeDetails?.[0];
  const selfCanAvail = selfServiceDetails?.canAvailService;
  const selfReason = selfServiceDetails?.nonServiceAvailabilityReason;
  const isSelfDisabled = selfCanAvail === false;

  return (
    <>
      {loading && (
        <div className="booking-loader-blur">
          <div className="loader-spinner"></div>
        </div>
      )}
        <>
          {finalPage ? (
            <NavigoFinalSectionContent
              familyMember={familyMember}
              provider={provider}
              memberRelation={memberRelation}
              service={service}
              price={selectedPrice}
              isCmp={isCmpBooking}
              // The slots screen is a STATE of this page, not a route, so back
              // has to return to the member list here. Without onBack the
              // BackButton fell through to navigating, and with no trail (the
              // CMP autologin entry pushes none) it landed on its last-resort
              // "/tab/home" — which an autologin session has no shell for, so
              // the screen went blank. bookingForSectionProvider already passes
              // this; this call site was simply missed.
              onBack={() => setFinalPage(false)}
            />
          ) : addressBook ? (
            <AddressBookContent
              familyMember={familyMember}
              booking={true}
              service={service}
              memberRelation={memberRelation}
              price={selectedPrice}
            />
          ) : (
            <div className="navigo-container-screen-2">
              <div className="navigo-container-screen-2-header">
                <img
                  src={backImage}
                  alt="icon"
                  onClick={() => {
                    // Never pop: see utils/navBack.js
                    goBackTo(history, routeLocation, "/navigo");
                    dispatch(
                      setStateFromPayload({
                        currScreen: 1,
                        familyMemberSelected: isForFamily
                          ? familyMemberSelected
                          : -2,
                        familyMemberSelectedData: isForFamily
                          ? familyMemberSelectedData
                          : {},
                        addressSelected: null,
                      })
                    );
                  }}
                />
                {/* <BackButton></BackButton> */}
                <div className="navigo-container-screen-2-main px-4">
                  <span className="font-semibold text-base leading-7 text-lightblack">
                    {familyData.firstName}
                  </span>
                </div>
              </div>
              <div className="navigo-container-screen-2-main">
                <div className="navigo-container-screen-2-main-mid">
                  <ProgressIndicator isInput={false} />
                </div>
                <p className="navigo-container-screen-2-main-mid-2">
                  Booking for
                </p>
                <div className="navigo-container-screen-2-main-family-list">
                  <div
                    className={`navigo-container-screen-2-main-family-list-ele ${
                      isSelfDisabled
                        ? "opacity-50 cursor-not-allowed"
                        : "cursor-pointer"
                    }`}
                    onClick={() => {
                      if (isSelfDisabled) return;
                      setHasUserSelected(true);
                      setSelectedRowId(-1);
                      setSelectedMemberId(-1);
                      dispatch(
                        setStateFromPayload({
                          familyMemberSelected: 0,
                          familyMemberSelectedData: { ...patientProfile },
                        })
                      );
                    }}
                  >
                    <div className="text-xs font-semibold text-[#97144D] mr-2 min-w-[40px]">
                      ₹{selfPrice}
                    </div>
                    <SecureImage
                      src={patientProfile.profileImage}
                      defaultImage={
                        patientProfile.gender === 1 ? FemaleActive : MaleActive
                      }
                    />
                    <div
                      className={`navigo-container-screen-2-main-family-list-ele-mid general-disabled-color-class}`}
                    >
                      <p className="navigo-container-screen-2-main-family-list-ele-mid-top">{`${
                        patientProfile.firstName
                      } ${
                        patientProfile.lastName ? patientProfile.lastName : ""
                      }`}</p>
                      <p className="navigo-container-screen-2-main-family-list-ele-mid-bottom">
                        {patientProfile.age ? `${patientProfile.age}, ` : ""}
                        self
                      </p>
                      {isSelfDisabled && selfReason && (
                        <p className="text-xs text-red-600 mt-1">
                          {selfReason}
                        </p>
                      )}
                    </div>

                    <input
                      type="radio"
                      style={{ accentColor: "#97144D" }}
                      checked={hasUserSelected && selectedRowId === -1}
                      onChange={() => {
                        if (isSelfDisabled) return;
                        setHasUserSelected(true);
                        setSelectedRowId(-1);
                        setSelectedMemberId(-1);
                        dispatch(
                          setStateFromPayload({
                            familyMemberSelected: 0,
                            familyMemberSelectedData: { ...patientProfile },
                          })
                        );
                      }}
                      disabled={isSelfDisabled}
                    />
                  </div>
                  {familyData.map((fd, index) => {
                    const serviceDetails =
                      pricesForFamily?.[fd.memberPatientId]
                        ?.serviceModeDetails?.[0];
                    const price = serviceDetails?.discountedPrice;
                    const canAvail = serviceDetails?.canAvailService;
                    const reason = serviceDetails?.nonServiceAvailabilityReason;

                    // A record with no memberPatientId cannot be priced or
                    // booked — everything downstream is keyed by it. Show it as
                    // unavailable rather than letting Continue send a null id.
                    const hasMemberId =
                      fd.memberPatientId !== null &&
                      fd.memberPatientId !== undefined &&
                      fd.memberPatientId !== "";
                    const isDisabled = canAvail === false || !hasMemberId;

                    return (
                      <div
                        key={fd.id}
                        className={`navigo-container-screen-2-main-family-list-ele ${
                          isDisabled
                            ? "opacity-50 cursor-not-allowed"
                            : "cursor-pointer"
                        }`}
                        onClick={() => {
                          if (isDisabled) return;
                          setHasUserSelected(true);
                          setSelectedRowId(fd.id);
                          setSelectedMemberId(fd.memberPatientId);
                          dispatch(
                            setStateFromPayload({
                              familyMemberSelected: fd.memberPatientId,
                              familyMemberSelectedData: { ...fd },
                              isUserSelectedFamily: true,
                            })
                          );
                        }}
                      >
                        <div className="text-xs font-semibold text-[#97144D] mr-2 min-w-[40px]">
                          {price === null || price === undefined
                            ? ""
                            : `₹${price}`}
                        </div>
                        <SecureImage
                          src={fd.profilePicURL}
                          defaultImage={
                            fd.gender === 1 ? FemaleActive : MaleActive
                          }
                        />
                        <div
                          className={`navigo-container-screen-2-main-family-list-ele-mid general-disabled-color-class}`}
                        >
                          <p className="navigo-container-screen-2-main-family-list-ele-mid-top">{`${
                            fd.firstName
                          } ${fd.lastName || ""}`}</p>
                          <p className="navigo-container-screen-2-main-family-list-ele-mid-bottom">
                            {fd.age ? `${fd.age}, ` : ""}
                            {getRelationByCode(fd.relation)?.value ||
                              "Relation"}
                          </p>
                          {/* 🛑 Show reason if unavailable */}
                          {isDisabled && reason && (
                            <p className="text-xs text-red-600 mt-1">
                              {reason}
                            </p>
                          )}
                        </div>
                        <input
                          type="radio"
                          style={{ accentColor: "#97144D" }}
                          checked={hasUserSelected && selectedRowId === fd.id}
                          onChange={() => {
                            if (isDisabled) return;
                            setHasUserSelected(true);
                            setSelectedRowId(fd.id);
                            setSelectedMemberId(fd.memberPatientId);
                            dispatch(
                              setStateFromPayload({
                                familyMemberSelected: fd.memberPatientId,
                                familyMemberSelectedData: { ...fd },
                                isUserSelectedFamily: true,
                              })
                            );
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="navigo-container-screen-2-bottom">
                {
                  <p
                    onClick={() => {
                      dispatch(
                        logEventWithData({
                          action: "navigo_add_family",
                          data: { is_app_event: true },
                        })
                      );
                      history.push({
                        pathname: "/family",
                        // Record the origin: without it the family screen's
                        // BackButton has nothing to return to and falls through
                        // to the home tab, which inside MLI's app reads as
                        // leaving the PWA entirely.
                        state: withFrom(routeLocation, {
                          isMedicine: true,
                          isPath: true,
                          path: "/navigo",
                        }),
                      });
                      // dispatch(
                      //   setStateFromPayload({
                      //     openFamily: true,
                      //     openAddFamily: true,
                      //     openFamilyProfile: false,
                      //   })
                      // );
                    }}
                  >
                    Add/Edit a family member
                  </p>
                }
                <button
                  disabled={!hasUserSelected}
                  onClick={() => handleAvailNow(selectedRowId)}
                >
                  Continue
                </button>
              </div>
            </div>
          )}
        </>
    </>
  );
}

export default function BookingForSection(props) {
  // Ionic can leave this page `ion-page-hidden` on re-entry, blanking it.
  const pageRef = useUnhidePageOnEnter();
  return (
    <IonPage ref={pageRef}>
      <IonContent>
        <BookingForSectionContent {...props} />
      </IonContent>
    </IonPage>
  );
}
